import {
  FinanceInfoDetailedFields,
  FinanceInfoVisibleFields,
  GeneralLoanInfoDetailedFields,
  GeneralLoanInfoVisibleFields,
  ProductInfoDetailedFields,
  ProductInfoVisibleFields,
  SubjectPropertyDetailedFields,
  SubjectPropertyVisibleFields
} from "./fields";
import { SchemaVersionEnum } from "./schema";
import { filterFieldsNotIncludedInDefaultSchema } from "../services/schemaTools";
import { defaultSchemaRuleArray } from "./defaultRules";
const EmptySchema = {
  version: SchemaVersionEnum.V5,
  schema: {
    theme: null,
    modules: [],
    screens: [
      {
        type: "screen_group",
        screens: []
      }
    ]
  },
  schemaRules: []
};
const NSSampleSchema = {
  version: SchemaVersionEnum.V5,
  schema: {
    theme: null,
    modules: [],
    screens: [
      {
        type: "screen_group",
        screens: [
          {
            // Refers to screens below
            id: "c8fc0171-c0c4-46fd-b81e-0c2e315512e2"
          },
          {
            id: "56cac222-e97d-4993-81c7-a0d86a92244a"
          },
          {
            id: "3cd6556e-a5e0-4c02-95ae-8da91a866ea0"
          },
          {
            id: "66cb28eb-7754-499e-bc0c-c399728f9598"
          }
        ]
      },
      {
        id: "c8fc0171-c0c4-46fd-b81e-0c2e315512e2",
        type: "screen",
        name: "General Loan Information",
        fields: [
          {
            type: "field_group",
            name: "VISIBLE",
            fields: GeneralLoanInfoVisibleFields
          },
          {
            type: "field_group",
            name: "DETAILED",
            fields: GeneralLoanInfoDetailedFields
          }
        ]
      },
      {
        id: "56cac222-e97d-4993-81c7-a0d86a92244a",
        type: "screen",
        name: "Product Information",
        fields: [
          {
            type: "field_group",
            name: "VISIBLE",
            fields: filterFieldsNotIncludedInDefaultSchema(
              ProductInfoVisibleFields
            )
          },
          {
            type: "field_group",
            name: "DETAILED",
            fields: ProductInfoDetailedFields
          }
        ]
      },
      {
        id: "3cd6556e-a5e0-4c02-95ae-8da91a866ea0",
        type: "screen",
        name: "Finance Information",
        fields: [
          {
            type: "field_group",
            name: "VISIBLE",
            fields: FinanceInfoVisibleFields
          },
          {
            type: "field_group",
            name: "DETAILED",
            fields: FinanceInfoDetailedFields
          }
        ]
      },
      {
        id: "66cb28eb-7754-499e-bc0c-c399728f9598",
        type: "screen",
        name: "Subject Property Information",
        fields: [
          {
            type: "field_group",
            name: "VISIBLE",
            fields: SubjectPropertyVisibleFields
          },
          {
            type: "field_group",
            name: "DETAILED",
            fields: SubjectPropertyDetailedFields
          }
        ]
      }
    ]
  },
  schemaRules: defaultSchemaRuleArray
};
const SamplePricingSearchConfigurationStore = [
  {
    channel: "Brokered",
    draftSchema: NSSampleSchema,
    modifiedOn: (/* @__PURE__ */ new Date()).getTime().toString(),
    publishedSchema: null,
    userLastEdited: "Dave"
  }
];
export {
  EmptySchema,
  NSSampleSchema,
  SamplePricingSearchConfigurationStore
};
